'use strict';

$(document).ready(function(){
    const timeBlock = $('.clock__time');

    function addTime() {
        moment.locale('ru')
        const data = '1988-08-09'
        const dateNow = moment();
        const dateNowNew = new Date()
        const dateStart = moment(data);
        const yearName = moment(data).fromNow().split(' ').slice(1, 2).join(' ');

        const yearsSum = dateNow.diff(dateStart, 'year');
        dateStart.add(yearsSum, 'years');

        const months = dateNow.diff(dateStart, 'months');
        dateStart.add(months, 'months');

        const days = dateNow.diff(dateStart, 'days');

        const hours = dateNowNew.getHours() >= 10 ? dateNowNew.getHours() : ('0' + dateNowNew.getHours());
        const minutes = dateNowNew.getMinutes() >= 10 ? dateNowNew.getMinutes() : ('0' + dateNowNew.getMinutes());
        const seconds = dateNowNew.getSeconds() >= 10 ? dateNowNew.getSeconds() : ('0' + dateNowNew.getSeconds());

        function getMonthName(monthNumber) {
            if (monthNumber < 1 || monthNumber > 4) {
                return ' месяцев, '
            } else if (monthNumber === 1) {
                return ' месяц, '
            } else {
                return ' месяца, '
            }
        }

        function getDayName(dayNumber) {
            if (dayNumber === 1 || dayNumber === 21 || dayNumber === 31) {
                return ' день, '
            } else if ((dayNumber > 1 && dayNumber < 5) || (dayNumber > 21 && dayNumber < 25)) {
                return ' дня, '
            } else {
                return ' дней, '
            }
        }

        timeBlock.html(yearsSum + ' ' + yearName + ', ' + months + getMonthName(months) + days + getDayName(days) + hours + ':' + minutes + ':' + seconds);


        // console.log(111, moment(data).fromNow())
    }

    addTime();
    const timer = setInterval(addTime, 1000);
    //
    // var a = moment();
    // var b = moment('1988-08-09');
    //
    // var years = a.diff(b, 'year');
    // b.add(years, 'years');
    //
    // var months = a.diff(b, 'months');
    // b.add(months, 'months');

    // var days = a.diff(b, 'days');

    // console.log(years + ' years ' + months + ' months ' + days + ' days');
});

